import Cookies from 'js-cookie';

import { env } from './env';
import { paramsKeys } from './consts/params';

/**
 * Checks whether the `'access_token'` cookie is present
 */
const isLoggedIn = (): boolean => !!Cookies.get(env.accessTokenKey);

/**
 * Saves Auth tokens to Cookies
 * @param accessToken
 * @param refreshToken
 */
const saveTokens = (accessToken: string, refreshToken = '') => {
  Cookies.set(env.accessTokenKey, accessToken, {
    domain: env.cookieDomain,
    path: '/',
    secure: true,
  });
  Cookies.set(env.refreshTokenKey, refreshToken, {
    domain: env.cookieDomain,
    path: '/',
    secure: true,
  });

  if (location.hostname === 'localhost') {
    Cookies.set(env.accessTokenKey, accessToken, {
      domain: 'localhost',
      path: '/',
      secure: true,
    });
    Cookies.set(env.refreshTokenKey, refreshToken, {
      domain: 'localhost',
      path: '/',
      secure: true,
    });
  }
};

/**
 * Clears Access and Refresh tokens from cookies
 */
const removeTokens = () => {
  Cookies.remove(env.accessTokenKey, {
    domain: env.cookieDomain,
    path: '/',
  });
  Cookies.remove(env.refreshTokenKey, {
    domain: env.cookieDomain,
    path: '/',
  });

  if (location.hostname === 'localhost') {
    Cookies.remove(env.accessTokenKey, {
      domain: 'localhost',
      path: '/',
    });
    Cookies.remove(env.refreshTokenKey, {
      domain: 'localhost',
      path: '/',
    });
  }
};

/**
 * Gets the access token from cookies
 */
const getAccessToken = () => Cookies.get(env.accessTokenKey);

/**
 * Gets the refresh token from cookies
 */
const getRefreshToken = () => Cookies.get(env.refreshTokenKey);

const redirectToExternalAuth = (
  additionalParams?: Partial<Record<(typeof paramsKeys)[keyof typeof paramsKeys], string>>,
) =>
  setTimeout(() => {
    const params = new URLSearchParams(location.search);

    params.append(paramsKeys.FROM, `order${window.location.pathname}`);
    params.delete(paramsKeys.ACCOUNT_ID);

    if (additionalParams) {
      Object.entries(additionalParams).forEach(([key, value]) => {
        params.append(key, value);
      });
    }

    window.location.href = `${env.cabinetUrl}/enter?${params.toString()}`;
  }, 0);

export { isLoggedIn, saveTokens, removeTokens, getAccessToken, getRefreshToken, redirectToExternalAuth };
